import React, { useEffect, useState } from 'react'
import Layout from '../../../components/layouts/Layout'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { fetchDepartments } from '../../../store/actions/departmentActions'
import { fetchDesignations } from '../../../store/actions/designationActions'
import { fetchDocuments } from '../../../store/actions/documentActions'
import { ERROR, SET_SUCCESS } from '../../../store/types'
import { clearOnboardedStaff, onboardStaff } from '../../../store/actions/staffActions'
import { 
    // parseNigerianStates, 
    slugify } from '../../../utils'
import TextField from '../../../components/elements/form/TextField'
import SelectField from '../../../components/elements/form/SelectField'
import Loader from '../../../components/elements/Loader'
import TrashIcon from '../../../components/elements/icons/TrashIcon'
import DateField from '../../../components/elements/form/DateField'
import { Switch } from '@headlessui/react'
import RadioGroup from '../../../components/elements/form/RadioGroup'
import FormButton from '../../../components/elements/form/FormButton'
import Breadcrumbs from '../../../components/elements/Breadcrumbs'
import { fetchRoles } from '../../../store/actions/rolesPermissionsActions'
// import moment from 'moment'
// import AutocompleteSelect from '../../../components/elements/form/AutocompleteSelect'
// import { Nationalities } from '../../../assets/static/nationalities';
// import { StatesLgas } from '../../../assets/static/stateslgas';

const OnboardStaff = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const rolesState = useSelector(state => state.roles)
    const staffState = useSelector(state => state.staff)
    const designationsState = useSelector(state => state.designations)
    const departmentsState = useSelector(state => state.departments)
    const documentsState = useSelector(state => state.documents)
  
    const requiredDocumentUploadSchema = 
    {
        name: "",
        description: ""
    }
  
  
    const employeeSchema = {
        // firstName: "",
        // otherNames: "",
        // employeeId: "",
        // lastName: "",
        // phone: "",
        // email: "",
        // createUserProfile: false,
        // department: "",
        // designation: "",
        // gender: "",
        address: {
            address: "",
            city: "",
            state: ""
        },
        designations: [""],
        // country: "",
        // state: "",
        // lga: "",
        requiredDocumentUploads: [requiredDocumentUploadSchema],
        requiredDocumentSignings: [""]
    }

    const [validationErrors, setValidationErrors] = useState({});
    const [employeePayload, setEmployeePayload] = useState(employeeSchema);
  
    useEffect(() => {
      dispatch(fetchDepartments())
      dispatch(fetchDesignations())
      dispatch(fetchDocuments())
      dispatch(fetchRoles('', 0, 0))
  
      if(staffState.onboardedStaff !== null) {
        dispatch({
          type: SET_SUCCESS,
          payload: "Staff onboarded successfully. An email has been sent to the user."
        })
        dispatch(clearOnboardedStaff())
        navigate('/admin/college-staff')
      }
      
      return () => {
        
      };
    }, [dispatch, staffState.onboardedStaff, navigate]);
  
    const updateRequiredDocuments = (index, field, value) => {
      let temp = {...employeePayload}
      temp.requiredDocumentUploads[index][field] = value
      if (field === 'documentName') {
        temp.requiredDocumentUploads[index].slug = slugify(value)
      }
  
      setEmployeePayload(temp)
    }
  
    const addRequiredDocumentUpload = (index, field, value) => {
      let temp = {...employeePayload}
      temp.requiredDocumentUploads.push(requiredDocumentUploadSchema)
  
      setEmployeePayload(temp)
    }
  
    const removeRequiredDocument = (index) => {
      let temp = {...employeePayload}
      temp.requiredDocumentUploads.splice(index, 1)
      setEmployeePayload(temp)
    }
  
    const updateRequiredDocumentSigning = (index, value) => {
      let temp = {...employeePayload}
      temp.requiredDocumentSignings[index] = value
  
      setEmployeePayload(temp)
    }
  
    const addRequiredDocumentSigning = () => {
      let temp = {...employeePayload}
      temp.requiredDocumentSignings.push("")
  
      setEmployeePayload(temp)
    }
  
    const removeRequiredDocumentSigning = (index, field, value) => {
      let temp = {...employeePayload}
      temp.requiredDocumentSignings.splice(index, 1)
      setEmployeePayload(temp)
    }

    const [showEmailWarning, setShowEmailWarning] = useState(false);
  
    const validateForm = () => {
        let errors = {}
        if (!employeePayload.firstName || employeePayload.firstName === '') {
            errors.firstName = true
        }
        if (!employeePayload.lastName || employeePayload.lastName === '') {
            errors.lastName = true
        }
        if (!employeePayload.department || employeePayload.department === '') {
            errors.department = true
        }
        if (!employeePayload.designations || employeePayload.designations.length === 0) {
            errors.designations = true
        }
        if (!employeePayload.phone || employeePayload.phone === '') {
            errors.phone = true
        }
        if (!employeePayload.email || employeePayload.email === '') {
            errors.email = true
        }
        if (!employeePayload.staffType || employeePayload.staffType === '') {
            errors.staffType = true
        }
        if (employeePayload.email && !employeePayload.email.endsWith('@vaatiacollege.com.ng')) {
            errors.email = true
            setShowEmailWarning(true)
        } else {
            setShowEmailWarning(false)
        }
        if (!employeePayload.gender || employeePayload.gender === '') {
            errors.gender = true
        }
        //   if (!employeePayload.religion || employeePayload.religion === '') {
        //       errors.religion = true
        //   }
        //   if (!employeePayload.dob || employeePayload.dob === '') {
        //       errors.dob = true
        //   }
        if (!employeePayload.startDate || employeePayload.startDate === '') {
            errors.startDate = true
        }
        //   if (!employeePayload.country || employeePayload.country === '') {
        //       errors.originCountry = true
        //   }
        //   if (!employeePayload.lga || employeePayload.lga === '') {
        //       errors.originLga = true
        //   }
        //   if (!employeePayload.state || employeePayload.state === '') {
        //       errors.originState = true
        //   }
        if (!employeePayload.address.address || employeePayload.address.address === '') {
            errors['address-address'] = true
        }
        if (!employeePayload.address.city || employeePayload.address.city === '') {
            errors['address-city'] = true
        }
        if (!employeePayload.address.state || employeePayload.address.state === '') {
            errors['address-state'] = true
        }
        if (employeePayload.createUserProfile === true && (!selectedRoles || selectedRoles.length === 0)) {
            errors.role = true
        }
    
        console.log(employeePayload)
        setValidationErrors(errors)
        return errors
    }
  
    const triggerCreateStaff = () => {
        if (Object.values(validateForm()).includes(true)) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            });
            return
        }

        const payload = {
            ...employeePayload, 
            frontendUrl: window.location.origin
        }
        if(employeePayload.createUserProfile === true){
            payload.adminRoles = selectedRoles
        }

        if(employeePayload.requiredDocumentSignings.length === 1 && employeePayload.requiredDocumentSignings[0] === ''){
            delete payload.requiredDocumentSignings
        }

        if(employeePayload.requiredDocumentUploads.length === 1 && employeePayload.requiredDocumentUploads[0].name === ''){
            delete payload.requiredDocumentUploads
        }


        dispatch(onboardStaff(payload))
    }

    const breadcrumbsData = [
        // {
        //   label: 'Dashboard',
        //   path: '/admin/dashboard'
        // },
        {
          label: 'College Staff',
          path: '/admin/college-staff'
        },
        {
          label: 'Onboarding Staff',
          path: '/admin/college-staff/onboard-new-staff',
          current: true
        },
    ]

    // const [activeLgas, setActiveLgas] = useState([])
    // const [lgasEnabled, setLgasEnabled] = useState(false)

    // const selectState = (selectedState) => {
    //     setLgasEnabled(false)
    //     setActiveLgas(StatesLgas.find((state)=>{
    //         return state.stateSlug === slugify(selectedState.label)
    //     }).lgas)

    //     setTimeout(() => {
    //         setLgasEnabled(true)
    //     }, 50);

    //     setEmployeePayload({...employeePayload, ...{state: selectedState.label}})
    // }

    // const [selectedPermissions, setSelectedPermissions] = useState([]);
    const [selectedRoles, setSelectedRoles] = useState([])

    const toggleRoleSelection = (roleId) => {
        let tempRoles = [...selectedRoles]
        if(tempRoles.includes(roleId)){
            tempRoles.splice(tempRoles.indexOf(roleId), 1)
        } else {
            tempRoles.push(roleId)
        }

        setSelectedRoles(tempRoles)
    }

    const [rolePermissionsOpen, setRolePermissionsOpen] = useState(null)
    const toggleRolePermissions = (index) => {
        if(rolePermissionsOpen === index){
            setRolePermissionsOpen(null)
        } else {
            setRolePermissionsOpen(index)
        }
    }
    // const [accountPermissionsList, setAccountPermissionsList] = useState(initialState);
  
    // const togglePermissionSelection = (sectionIndex, permissionIndex) => {
    //   let tempPermissions = [...selectedPermissions]
  
    //   const selectedPermission = rolesState.permissions.sections[sectionIndex].permissions[permissionIndex].value
    //   if(permissionIndex === 0 && !tempPermissions.includes(selectedPermission)) {
    //     rolesState.permissions.sections[sectionIndex].permissions.forEach((option) => {
    //       tempPermissions.push(option.value)
    //     })
    //   } else if (permissionIndex === 0 && tempPermissions.includes(selectedPermission)) {
    //     rolesState.permissions.sections[sectionIndex].permissions.forEach((option, index) => {
    //       tempPermissions.splice(index, 1)
    //     })
    //   } else {
    //     // tempPermissions.sections[sectionIndex].permissions[permissionIndex].selected = !tempPermissions.sections[sectionIndex].permissions[permissionIndex].selected
    //     if(tempPermissions.includes(selectedPermission)) {
    //       const indexOfPermission = tempPermissions.findIndex(perm => perm === selectedPermission)
    //       tempPermissions.splice(indexOfPermission, 1)
    //     } else {
    //       tempPermissions.push(selectedPermission)
    //     }
    //   }
  
    //   setSelectedPermissions(tempPermissions)
    // }

    const updateAddress = (field, value) => {
        let temp = {...employeePayload}
        temp.address[field] = value
        setEmployeePayload(temp)
    }

    const updateDesignation = (index, value) => {
        let temp = {...employeePayload}
        temp.designations[index] = value
        setEmployeePayload(temp)
    }

    const removeDesignation = (index) => {
        let temp = {...employeePayload} 
        temp.designations.splice(index, 1)
        setEmployeePayload(temp)
    }

    return (
        <Layout pageTitle={`Onboard new staff`}>

            <Breadcrumbs breadcrumbsData={breadcrumbsData} />

            <div className='w-10/12 xl:w-8/12 2xl:w-5/12 mx-auto mt-6 p-8 bg-white'>
            <h3 className='font-medium'>Employee/Staff Details</h3>
            <p className='text-sm mb-3'>Please provide employee details below</p>

            <div className='my-4 w-full'>
                <TextField
                    inputLabel="First name" 
                    fieldId="first-name" 
                    inputType="text" 
                    preloadValue={''}
                    inputPlaceholder={`Staff first or preferred name`}
                    requiredField={true}
                    hasError={validationErrors.firstName} 
                    returnFieldValue={(value)=>{setEmployeePayload({...employeePayload, ...{firstName: value}})}}
                />
            </div>

            <div className='my-4 w-full'>
                <TextField
                    inputLabel="Last name" 
                    fieldId="last-name" 
                    inputType="text" 
                    requiredField={true}
                    inputPlaceholder={`Staff surname`}
                    preloadValue={''}
                    hasError={validationErrors.lastName} 
                    returnFieldValue={(value)=>{setEmployeePayload({...employeePayload, ...{lastName: value}})}}
                />
            </div>

            <div className='my-4 w-full'>
                <TextField
                    inputLabel="Other names" 
                    fieldId="middle-name" 
                    inputPlaceholder={`Staff middle name`}
                    inputType="text" 
                    preloadValue={''}
                    hasError={false} 
                    returnFieldValue={(value)=>{setEmployeePayload({...employeePayload, ...{otherNames: value}})}}
                />
            </div>

            <div className='mt-4'>
                <RadioGroup 
                    items={[
                        {
                            label: 'Female',
                            value: 'FEMALE'
                        },
                        {
                            label: 'Male',
                            value: 'MALE'
                        }
                    ]} 
                    preSelectedIndex={''}
                    inputLabel={'Gender'}
                    requiredField={true}
                    returnSelected={(value) => {setEmployeePayload({...employeePayload, ...{gender: value.value}})}} 
                    hasError={validationErrors && validationErrors.gender}  
                    titleField='label'
                />
            </div>

            <h3 className='font-medium mt-12'>Contact details</h3>
            <p className='text-sm mb-3'>How can this employee be reached
            </p>
            <div className='my-4 w-full'>
                <TextField
                    inputLabel="Employee email address" 
                    fieldId="employee-email" 
                    inputType="text" 
                    inputPlaceholder={`Staff middle name eg: staff.name@vaatiacollege.com.ng`}
                    preloadValue={''}
                    requiredField={true}
                    hasError={validationErrors.email} 
                    returnFieldValue={(value)=>{setEmployeePayload({...employeePayload, ...{email: value}})}}
                />
                {showEmailWarning && <label 
                    className={`text-sm cursor-text z-10 relative py-1 transition mb-2 block duration-200 text-red-600`}
                >
                    Email address must be a valid Vaatia College email.
                </label>}
            </div>
            <div className='my-4 w-full'>
                <TextField
                    inputLabel="Employee phone number" 
                    fieldId="employee-phone" 
                    inputType="text" 
                    preloadValue={''}
                    requiredField={true}
                    hasError={validationErrors.phone} 
                    inputPlaceholder={`Active phone number`}
                    returnFieldValue={(value)=>{setEmployeePayload({...employeePayload, ...{phone: value}})}}
                />
            </div>
            <div className='my-4 w-full'>
                <TextField
                    inputLabel="Address" 
                    fieldId="employee-address" 
                    inputType="text" 
                    requiredField={true}
                    preloadValue={''}
                    hasError={validationErrors['address-address']} 
                    inputPlaceholder={`Employee physical address`}
                    returnFieldValue={(value)=>{updateAddress('address', value)}}
                />
            </div>
            <div className='my-4 w-full'>
                <TextField
                    inputLabel="City" 
                    fieldId="employee-address-city" 
                    inputType="text" 
                    requiredField={true}
                    preloadValue={''}
                    hasError={validationErrors['address-city']} 
                    inputPlaceholder={`City or LGA (eg: Makurdi)`}
                    returnFieldValue={(value)=>{updateAddress('city', value)}}
                />
            </div>
            <div className='my-4 w-full'>
                <TextField
                    inputLabel="State" 
                    fieldId="employee-address-state" 
                    inputType="text" 
                    requiredField={true}
                    preloadValue={''}
                    hasError={validationErrors['address-state']} 
                    inputPlaceholder={`Address state (eg: Benue)`}
                    returnFieldValue={(value)=>{updateAddress('state', value)}}
                />
            </div>

            <h3 className='font-medium mt-12'>Staff placement</h3>
            <p className='text-sm mb-3'>Please designate employees placement
            </p>

            <div className='mt-4'>
                <RadioGroup 
                    items={[
                        {
                            label: 'Academic',
                            value: 'ACADEMIC'
                        },
                        {
                            label: 'Non-academic',
                            value: 'NON_ACADEMIC'
                        }
                    ]} 
                    preSelectedIndex={''}
                    inputLabel={'Staff Member Type'}
                    requiredField={true}
                    returnSelected={(value) => {
                        setEmployeePayload({...employeePayload, ...{staffType: value.value}})
                        dispatch(fetchDepartments(`type=${value.value === 'ACADEMIC' ? 'academic' : 'non-academic'}`))
                    }} 
                    hasError={validationErrors && validationErrors.staffType}  
                    titleField='label'
                />
            </div>

            {departmentsState.loadingDepartments ? 
                <Loader preloadingText={`fetching departments...`} />
            :

            <>
                {departmentsState?.departments?.departments?.length > 0 ? <div className='my-4 w-full'>
                    <SelectField
                        selectOptions={departmentsState?.departments?.departments}
                        inputLabel="Select Department"
                        titleField="name"
                        displayImage={false}
                        imageField=""
                        preSelected=''
                        fieldId="employee-department"
                        requiredField={true}
                        hasError={validationErrors.department}
                        // return id of accounts of the selected option
                        returnFieldValue={(value) => {setEmployeePayload({...employeePayload, ...{department: value._id}})}}
                    />
                    <p className='text-xs mt-2 text-gray-500'>Select a department above to assign this user to a department</p>
                </div> 
                :
                <div className='my-5 p-4 rounded border border-red-500 bg-red-300 bg-opacity-20 text-center'>
                    <p className='text-xs text-red-500'>No departments created yet. please create some in the administrations section first.</p>
                </div>
                }
            </>
            }
            
            <h3 className='font-medium mt-5 text-[15px]'>Designations</h3>
            <p className='text-[13px] mt-1 text-gray-500'>Assign the user one or more designations by selecting above. Select "Add another designation" to add more.</p>

            {designationsState.fetchingDesignations ? 
                <Loader preloadingText={`fetching designations...`} />
            :
                <>
                    {designationsState?.designations?.designations?.length > 0 ? 
                    <div className='my-4 w-full'>
                        {employeePayload.designations?.map((_designation, designationIndex)=>(
                            <div className="my-2 relative" key={designationIndex}>
                                {designationIndex > 0 && <button onClick={()=>{removeDesignation(designationIndex)}} className='absolute z-50 top-1 right-0 flex items-center gap-x-2 text-red-600 hover:text-red-800 duration-200 transition text-xs'>
                                    <TrashIcon className={`w-5 h-5`} />
                                    Remove designation
                                </button>}

                                <SelectField
                                    selectOptions={designationsState?.designations?.designations}
                                    inputLabel="Select Designation"
                                    titleField="name"
                                    displayImage={false}
                                    imageField=""
                                    preSelected=''
                                    fieldId="employee-designation"
                                    requiredField={true}
                                    hasError={validationErrors[`designation-${designationIndex}`]}
                                    // return id of accounts of the selected option
                                    returnFieldValue={(value) => {updateDesignation(designationIndex, value._id)}}
                                />
                            </div>
                        ))}
                       
                        <button onClick={()=>{setEmployeePayload({...employeePayload, designations: [...employeePayload.designations, '']})}} className='w-full p-3 text-sm border border-dashed border-gray-500 transition duration-200 text-gray-800 rounded-lg mt-2 font-space-grotesk font-semibold'>Add another designation</button>
                    </div> 
                    : 
                    <div className='my-5 p-4 rounded border border-red-500 bg-red-300 bg-opacity-20 text-center'>
                        <p className='text-xs text-red-500'>No designations created yet. please create some in the administrations section first.</p>
                    </div>
                    }
                </>
            }

            <div className='my-4 w-full'>
                <DateField
                    inputLabel="Start date" 
                    fieldId="employee-start-date" 
                    inputType="text" 
                    requiredField={true}
                    preloadValue={''}
                    hasError={validationErrors.startDate} 
                    returnFieldValue={(value)=>{setEmployeePayload({...employeePayload, ...{startDate: value}})}}
                />
                <p className='text-xs mt-2 text-gray-400'>Choose the date when the employee should resume work</p>
            </div>

            <h3 className='font-medium mt-12'>User Onboarding</h3>
            <p className='text-sm mb-3'>What is required of the user while onboarding?
            </p>

            <p className='text-sm mt-6 mb-3'>Add documents that this employee will be required to provide as part of their onboarding process.
            <br /> <span className='text-vcm-purple'>You can skip this if no documents are required</span>
            </p>

            {employeePayload.requiredDocumentUploads && <div className='w-full px-4 py-4 rounded bg-white mb-6 border border-gray-200'>
            {employeePayload.requiredDocumentUploads?.map((requiredUpload, requiredUploadIndex)=>(
                <div key={requiredUploadIndex} className='w-full mt-6 relative'>
                {requiredUploadIndex > 0 && 
                    <button onClick={()=>{removeRequiredDocument(requiredUploadIndex)}} className='absolute z-50 cursor-pointer top-0 right-0 flex items-center gap-x-2 text-red-600 hover:text-red-800 duration-200 transition text-xs'>
                    <TrashIcon className={`w-5 h-5`} />
                    Remove document
                    </button>
                }
                <div className='w-full'>
                    <TextField
                        inputLabel="Document name" 
                        fieldId="document-name" 
                        inputType="text" 
                        preloadValue={requiredUpload.name || ''}
                        inputPlaceholder={`Eg: Degree certificate`}
                        hasError={false} 
                        returnFieldValue={(value)=>{updateRequiredDocuments(requiredUploadIndex, 'name', value)}}
                    />
                </div>
                <div className='my-4 w-full'>
                    <TextField
                        inputLabel="Document description" 
                        fieldId="document-desc" 
                        inputType="text" 
                        preloadValue={requiredUpload.description || ''}
                        hasError={false} 
                        inputPlaceholder={`Brief description of what the document is`}
                        returnFieldValue={(value)=>{updateRequiredDocuments(requiredUploadIndex, 'description', value)}}
                    />
                    <p className='text-xs mt-2 text-gray-400'></p>

                </div>

                </div>
            ))}

            <button onClick={()=>{addRequiredDocumentUpload()}} className='w-full p-3 text-sm border border-dashed border-gray-500 transition duration-200 text-gray-800 rounded-lg mt-2 font-space-grotesk font-semibold'>Add another document</button>
            </div>}

            <p className='text-sm mt-6 mb-3'>Select documents that this employee will be required to sign as part of their onboarding.
            <br /> <span className='text-vcm-purple'>You can skip this if no documents are required for signing</span>
            
            </p>
            {employeePayload.requiredDocumentSignings && <div className='w-full px-4 py-4 rounded bg-white mb-6 border border-gray-200'>
            {employeePayload.requiredDocumentSignings?.map((requiredSigning, requiredSigningIndex)=>(
                <div key={requiredSigningIndex} className='w-full mt-6 relative'>
                {requiredSigningIndex > 0 && 
                    <button onClick={()=>{removeRequiredDocumentSigning(requiredSigningIndex)}} className='absolute z-50 cursor-pointer top-0 right-0 flex items-center gap-x-2 text-red-600 hover:text-red-800 duration-200 transition text-xs'>
                        <TrashIcon className={`w-5 h-5`} />
                        Remove document 
                    </button>
                }
                {documentsState.fetchingDocuments ? 
                    <Loader preloadingText={`fetching documents...`} />
                :
                <>
                    {documentsState?.documents?.documents ? 
                        <div className='my-4 w-full'>
                            <SelectField
                                selectOptions={documentsState?.documents?.documents}
                                inputLabel="Select Document"
                                titleField="name"
                                displayImage={false}
                                imageField=""
                                preSelected={requiredSigning}
                                fieldId={`required-document-signing-${requiredSigningIndex}`}
                                hasError={false}
                                returnFieldValue={(value) => {updateRequiredDocumentSigning(requiredSigningIndex, value._id)}}
                            />
                            {/* <p className='text-xs mt-2 text-gray-400'>Select a department above to assign this user to a department</p> */}
                        </div> 
                    : 
                        <div className='my-5 p-4 rounded border border-red-500 bg-red-300 bg-opacity-20'>
                            <p className='text-xs text-red-500'>No documents created yet. If documents are required, please create them in the administration section</p>
                        </div>
                    }
                </>
                }

                </div>
            ))}

            <button onClick={()=>{addRequiredDocumentSigning()}} className='w-full p-3 text-sm border border-dashed border-gray-500 transition duration-200 text-gray-800 rounded-lg mt-2 font-space-grotesk font-semibold'>Add another document</button>
            </div>}

            {/* <div className='my-4 w-full'>
                <RadioGroup
                    inputLabel="Gender"
                    inline={true}
                    items={[
                        {label: 'Female', value: 'FEMALE'},
                        {label: 'Male', value: 'MALE'},
                    ]} 
                    hasError={validationErrors.gender} 
                    returnSelected={(value)=>{setEmployeePayload({...employeePayload, ...{gender: value.value}})}}
                />
            </div> */}

            {/* <h3 className='font-medium mt-12'>User Access</h3>
            <p className='text-sm mb-3'>Designate user's access to this platform</p> */}

            <div className='w-full my-4 flex gap-x-4 items-center justify-between'>
                <div  className='w-full'>
                    <p className="text-gray-600">
                        Create a user profile?
                    </p>
                    <p className='text-sm text-gray-400'>Creating a user profile means the user will have access to this platform.</p>
                </div>
                <div className='w-24 flex flex-row-reverse'>
                    <Switch
                        checked={employeePayload.createUserProfile}
                        onChange={()=>{
                            setEmployeePayload({...employeePayload, ...{createUserProfile: !employeePayload.createUserProfile}})
                            dispatch(fetchRoles())
                            }}
                        className={`${
                        employeePayload.createUserProfile ? 'bg-vcm-purple' : 'bg-gray-200'
                        } relative inline-flex items-center h-5 rounded-full w-10`}
                        >
                        {/* <span className="sr-only">Display stock levels</span> */}
                        <span
                            className={`transform transition ease-in-out duration-200 ${
                            employeePayload.createUserProfile ? 'translate-x-6' : 'translate-x-1'
                            } inline-block w-3 h-3 transform bg-white rounded-full`}
                        />
                    </Switch>
                </div>
            </div>

            {employeePayload.createUserProfile && <>

            {/* <div className='my-4 w-full'>
                <h3 className='font-medium mt-6 mb-2'>User Role</h3>
                <p className='text-sm mb-12'>Select the role for this employee's user account. this will define what king of access they have on this platform. You can create a new role from the roles tab above.</p>

                {rolesState.loadingRoles ? 
                <Loader preloadingText={`fetching roles...`} />
                :
                <>
                    {rolesState?.roles?.roles?.length > 0 ? <div className='my-4 w-full'>
                        <SelectField
                            selectOptions={rolesState?.roles?.roles}
                            inputLabel="Select Role"
                            titleField="name"
                            displayImage={false}
                            imageField=""
                            preSelected={``}
                            fieldId={`user-role`}
                            hasError={validationErrors && validationErrors.role}
                            returnFieldValue={(value)=>{setEmployeePayload({...employeePayload, ...{role: value._id}})}}
                        />
                    </div> : 
                    <div className='my-5 p-4 rounded border border-red-500 bg-red-300 bg-opacity-20'>
                        <p className='text-xs text-red-500'>No roles created yet</p>
                    </div>
                    }
                </>
                }
            </div> */}

            <h3 className='font-medium mt-6 mb-2'>User Roles</h3>
              <p className='text-sm mb-12'>Use the toggles below select which roles the user will have on this system.</p>

              {rolesState.loadingRoles ? 
                <Loader preloadingText={`fetching roles...`} />
              :
              <>
                {/* {rolesState?.permissions?.sections.map((section, sectionIndex)=>(<div className='w-full mb-8' key={sectionIndex}>
                    <h3 className="font-medium text-sm">{section.title}</h3>
                    {section.permissions.map((permission, permissionIndex)=>(<div key={permissionIndex} className='w-full my-4 flex gap-x-4 items-center justify-between'>
                      <div className='w-full'>
                        <p className="text-sm text-gray-600">
                            {permission.label}
                        </p>
                      </div>
                      <div className='w-24'>
                        <Switch
                            checked={selectedPermissions.includes(permission.value)}
                            onChange={()=>{togglePermissionSelection(sectionIndex, permissionIndex)}}
                            className={`${
                              selectedPermissions.includes(permission.value) ? 'bg-vcm-purple' : 'bg-gray-200'
                            } relative inline-flex items-center h-5 rounded-full w-10`}
                            >
                            <span
                                className={`transform transition ease-in-out duration-200 ${
                                  selectedPermissions.includes(permission.value) ? 'translate-x-6' : 'translate-x-1'
                              } inline-block w-3 h-3 transform bg-white rounded-full`}
                            />
                        </Switch>
                      </div>
                    </div>))}
                  </div>
                  
                ))} */}

                {rolesState?.roles?.roles?.map((role, roleIndex) => (
                    <div key={roleIndex} className='p-[20px] bg-gray-100 bg-opacity-50 rounded-[8px] my-[10px] flex items-start gap-x-[10px]'>
                        <div className='w-full'>
                            <h3 className='font-space-grotesk text-gray-800 font-[550]'>{role.name}</h3>
                            <p className='text-sm text-gray-500'>{role.description}</p>
                            <span className='p-[7px] rounded-[6px] text-xs bg-gray-200 bg-opacity-75 inline-block mt-[15px]'>{role.permissions.length} permission(s) </span><button className='underline text-xs ml-[5px] text-vcm-purple' onClick={()=>{toggleRolePermissions(roleIndex)}}>Click to {rolePermissionsOpen === roleIndex ? 'hide' : 'show'} permissions</button>
                            {rolePermissionsOpen === roleIndex && <div className='mt-[20px]'>
                                <p className='text-[13px] text-gray-600'>{role.permissions.join(', ')}</p>
                            </div>}
                        </div>
                        <div className='w-24 flex flex-row-reverse'>
                            <Switch
                                checked={selectedRoles.includes(role._id)}
                                onChange={()=>{toggleRoleSelection(role._id)}}
                                className={`${
                                selectedRoles.includes(role._id) ? 'bg-accent' : 'bg-gray-400'
                                } relative inline-flex items-center h-5 rounded-full w-10`}
                                >
                                <span
                                    className={`transform transition ease-in-out duration-200 ${
                                    selectedRoles.includes(role._id) ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                                } inline-block w-3 h-3 transform rounded-full`}
                                />
                            </Switch>
                        </div>
                    </div>
                ))}
              </>}
                
            </>}

            <div className='my-8 flex flex-row-reverse items-center justify-between'>
                <div className='w-full'>
                    <FormButton 
                        buttonLabel={`Create Employee`} 
                        buttonAction={()=>{triggerCreateStaff()}} 
                        processing={staffState.onboardingStaff}
                    />
                </div>
            </div>

        </div>
        </Layout>
    )
}

export default OnboardStaff